import {
  CustomizationDataDto,
  ExcelExportRequestDto,
  SortColumnDto,
} from '@asset-metrix/portal-gateway-client-js';
import { triggerDownloadWithAnchorTag } from '@asset-metrix/portal-ui';

import { getContentDispositionFileExtension } from '../../utils/contentDisposition';
import { extractErrorMessage } from '../../utils/errorMessage';
import { HttpError } from '../errors';
import { portalGatewayClient } from '../portalGatewayClient';

import { convertSortItemsToSortString } from './datatableData';

export const datatableExcelDownload = async ({
  actionRowIds,
  fileName,
  format = 'excel',
  readOnly,
  selection,
  sortItems,
  widgetId,
  workflowStateSelection,
  customization,
  stakeAdjusted,
  groupByColumnId,
  onlyGroupRows,
  skipAggregatedFilter,
}: Partial<ExcelExportRequestDto> & {
  fileName?: string;
  sortItems?: SortColumnDto[];
  widgetId: string;
  customization?: CustomizationDataDto;
  stakeAdjusted?: boolean;
  actionRowIds?: string[] | number[];
  groupByColumnId?: string;
  onlyGroupRows?: boolean;
  skipAggregatedFilter?: boolean;
}) => {
  const sort = convertSortItemsToSortString(sortItems ?? []);

  const response = await portalGatewayClient.table.downloadTableExcelExport(
    widgetId,
    {
      ...(sort != null && { sort }),
    },
    {
      selection: selection ?? {},
      format,
      readOnly,
      workflowStateSelection,
      customization,
      stakeAdjusted,
      ...(groupByColumnId ? { groupByColumnId } : {}),
      ...(onlyGroupRows ? { onlyGroupRows } : {}),
      ...(skipAggregatedFilter ? { skipAggregatedFilter } : {}),
      ...(actionRowIds != null && actionRowIds.length > 0
        ? { actionRowIds }
        : {}),
    }
  );

  if (!response.ok) {
    throw new HttpError(
      extractErrorMessage(response.error, 'Error fetching export file'),
      response
    );
  }

  const contentDisposition = response.headers.get('content-disposition');

  // Use file extension from content-disposition header, because automatic extension assignment only works if the target system knows the mime type of the blob and the file name does not contain anything that already looks like an extension
  const fileExtension = contentDisposition
    ? getContentDispositionFileExtension(contentDisposition)
    : null;

  const blob = await response.blob();
  const blobUrl = URL.createObjectURL(blob);
  triggerDownloadWithAnchorTag(
    blobUrl,
    fileExtension ? `${fileName}.${fileExtension}` : fileName
  );
};
